var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "pen",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.04 27.096l-9.38 9.44-17.2-17.2 9.45-9.37.02-.02a4.581 4.581 0 016.478-.023l.022.023 10.5 10.52a4.6 4.6 0 01.13 6.61l-.02.02zm-79.52 56.87l2.37-14.37 3.6-3.57h8.12v9.371h9.37v8.119l-3.57 3.6-14.37 2.371-5.52-5.521zm13.04-24.98l33.26-33.03 17.229 17.23-33.03 33.259v-8.08h-9.38v-9.379H23.56zm72.46-44.6L85.5 3.866c-5.145-5.15-13.489-5.155-18.639-.011l-.012.011L4.87 65.456l-4.8 29.1a4.69 4.69 0 005.38 5.39l29.1-4.799 61.591-62c5.146-5.154 5.142-13.506-.013-18.654-.036-.036-.071-.072-.108-.107z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon_pencil.00014adf26b36df6fcba1b9f19611c40.svg";
export { ForwardRef as ReactComponent };